const ACCESS_TOKEN_KEY = "token";
const USER_INFO_KEY = "userInfo";
export const AUTH_UNAUTHORIZED_EVENT = "auth:unauthorized";

function storages() {
  return [window.localStorage, window.sessionStorage];
}

export function getAccessToken() {
  if (typeof window === "undefined") {
    return null;
  }
  return window.localStorage.getItem(ACCESS_TOKEN_KEY)
    || window.sessionStorage.getItem(ACCESS_TOKEN_KEY);
}

export function setAccessToken(token: string, persistent = true) {
  if (typeof window === "undefined") {
    return;
  }
  const target = persistent ? window.localStorage : window.sessionStorage;
  const stale = persistent ? window.sessionStorage : window.localStorage;
  stale.removeItem(ACCESS_TOKEN_KEY);
  target.setItem(ACCESS_TOKEN_KEY, token);
}

export function isAccessTokenPersistent() {
  return typeof window !== "undefined"
    && Boolean(window.localStorage.getItem(ACCESS_TOKEN_KEY));
}

export function setStoredUserInfo(userInfo: unknown, persistent = true) {
  if (typeof window === "undefined") {
    return;
  }
  const target = persistent ? window.localStorage : window.sessionStorage;
  const stale = persistent ? window.sessionStorage : window.localStorage;
  stale.removeItem(USER_INFO_KEY);
  target.setItem(USER_INFO_KEY, JSON.stringify(userInfo));
}

export function clearAccessToken() {
  if (typeof window === "undefined") {
    return;
  }
  storages().forEach(storage => storage.removeItem(ACCESS_TOKEN_KEY));
}

export function clearAuthStorage() {
  if (typeof window === "undefined") {
    return;
  }
  storages().forEach(storage => {
    storage.removeItem(ACCESS_TOKEN_KEY);
    storage.removeItem(USER_INFO_KEY);
  });
}
